export default function Page403() {
  return <div className="page-container">用户无权限</div>;
}
